export const CUBE_ID = 'facts_slides';
export const REPORT_ID = 'lead-countries-major-crops-population-forecast';
export const REPORT_APE_ID = 'lead-countries-major-crops-population-forecast-ape';

export const CATEGORIES_AXIS = "countries.default";
export const SERIES_AXIS = "calendar.default";